// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"419af693","909":"501fbdcb","933":"44a2d653"}[chunkId] + ".chunk.js";
};